module.exports = __webpack_public_path__ + "static/media/Rollo.33443fc9.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Rollo.otf
// module id = 3693
// module chunks = 68